import { MaterialToSubmissionFormData } from "@dune/types";
import { Button, MultipleSelector } from "@dune/ui";
import { useFormContext } from "react-hook-form";
import { useShouldDisplayHTAmount } from "../../../../hooks/useParticipantToSubmissionForm";
import { ParticipantDocumentsTable } from "./DocumentsTable";
import { ControlledPriceInput } from "../../../../components/inputs/ControlledPriceInput";

interface MaterialToSubmissionFormProps {
	constructionSiteId: number;
	onSubmit: () => void;
	onCancel: () => void;
	isSubmitting?: boolean;
	documentsSlot?: React.ReactNode;
}

export const MaterialToSubmissionForm = ({
	constructionSiteId,
	onSubmit,
	onCancel,
	isSubmitting = false,
	documentsSlot,
}: MaterialToSubmissionFormProps) => {
	const {
		control,
		watch,
		setValue,
		formState: { errors },
	} = useFormContext<MaterialToSubmissionFormData>();

	const { shouldDisplayHT } = useShouldDisplayHTAmount(constructionSiteId);

	return (
		<div className="space-y-6">
			{documentsSlot ?? (
				<ParticipantDocumentsTable
					constructionSiteId={constructionSiteId}
					participantType="MATERIAL"
				/>
			)}
			<MultipleSelector
				label="Types de matériaux"
				options={[]}
				placeholder="Ajouter"
				creatable={true}
				value={(watch("materialTypes") || []).map((material) => ({
					value: material,
					label: material,
				}))}
				onChange={(selectedOptions) => {
					const materials = selectedOptions.map((option) => option.value);
					setValue("materialTypes", materials);
				}}
				error={errors.materialTypes?.message}
			/>

			<div className="space-y-4">
				{shouldDisplayHT ? (
					<ControlledPriceInput
						control={control}
						name="totalFeesHT"
						label="Montant HT"
						iconOrText="€ HT"
						required
					/>
				) : (
					<ControlledPriceInput
						control={control}
						name="totalFeesTTC"
						label="Montant TTC"
						iconOrText="€ TTC"
						required
					/>
				)}
			</div>

			<div className="flex justify-end space-x-3">
				<Button
					type="button"
					variant="outline"
					onClick={onCancel}
					disabled={isSubmitting}
				>
					Annuler
				</Button>
				<Button
					type="button"
					onClick={onSubmit}
					disabled={isSubmitting}
					isLoading={isSubmitting}
				>
					Enregistrer
				</Button>
			</div>
		</div>
	);
};
